import React from 'react';
import './style.scss';
import clsx from 'clsx';
import Item from './Item';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { withTranslation } from 'react-i18next';
import { FreeMode } from 'swiper';

const InfographicNumbers = ({ fields = {}, params, i18n }) => {
  // Destructuring fields
  const { items } = fields;
  // Conditional rendering
  const shouldRenderItems = Array?.isArray(items) && items?.length > 0;

  return (
    shouldRenderItems && (
      <div className={clsx('infographic-number content', 'add-margins', params?.Styles)}>
        {/* We don't need swiper on non mobile devices */}
        <div className="row d-none d-md-flex infographic-items without-swiper">
          {items.map((item, index) => {
            return <Item key={index} data={item?.fields} />;
          })}
        </div>
        {/* We want to apply swiper on mobile only */}
        <Swiper
          modules={[FreeMode]}
          dir={i18n?.language === 'en' ? 'ltr' : 'rtl'}
          spaceBetween={16}
          freeMode={true}
          slidesPerView={'auto'}
          className="infographic-items d-md-none"
        >
          {items?.map((item, index) => {
            return (
              <SwiperSlide className="swiper-slide-item" key={index}>
                <Item data={item?.fields} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    )
  );
};

export default withTranslation()(InfographicNumbers);
